const state = {
    lang: 'ru', // default language
    setScreenSize: 'xl'
}

const getters = {
    StateLang: (state) => state.lang,
    StateScreenSize: (state) => state.screen_size
}

const actions = {
    async SetLang({ commit }, lang) {
        try {
            await commit("setLang", lang).then(res=>res)
        } catch { }
        return true
    },
    async setScreenSize({ commit }, size) {
        try {
            await commit("setScreenSize", size)
        } catch { }
        return true
    }
}

const mutations = {
    setLang(state, lang) {
        state.lang = lang
    },
    setScreenSize(state, size) {
        state.screen_size = size
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}